import type { VariablesType } from './types';

export const VARIABLES: VariablesType = {
  Version: 'unknown',
  ClientAppVersion: 'unknown',
  AppEnv: 'development',
  LogInRedirectForWeb: '/auth/sign-in?ReturnUrl=%2F', // relative to baseHref
  LogOutRedirectForWeb: '/auth/sign-out?ReturnUrl=%2F', // relative to baseHref
  UseStaticResources: false
};

declare let FRIA_DAMAGEDOC_WEBPACK_CONFIG: { vars: Partial<VariablesType> } | undefined;

if (typeof FRIA_DAMAGEDOC_WEBPACK_CONFIG !== 'undefined') {
  Object.assign(VARIABLES, FRIA_DAMAGEDOC_WEBPACK_CONFIG.vars);
}

